<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: 'min(28rem, 94vw)'}"
  [header]="'shared.qr.dialog.title' | translate"
  (onHide)="hide()"
>
  <div *ngIf="data" class="qr-dialog">
    <div class="qr-dialog__preview">
      <div class="qr-dialog__card">
        <img
          *ngIf="qrImageUrl"
          [src]="qrImageUrl"
          [alt]="data.title"
          class="qr-dialog__image"
        />
        <div class="qr-dialog__card-title">{{ data.title }}</div>
      </div>
    </div>

    <div class="qr-dialog__content">
      <h3 class="qr-dialog__title">{{ data.title }}</h3>
      <p *ngIf="data.subtitle" class="qr-dialog__subtitle">{{ data.subtitle }}</p>
      <p class="qr-dialog__description">{{ 'shared.qr.dialog.description' | translate }}</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="qr-dialog__footer">
      <button
        pButton
        type="button"
        class="p-button-text p-button-rounded"
        (click)="hide()"
        [label]="'common.close' | translate"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-outlined p-button-rounded"
        icon="pi pi-image"
        (click)="shareQr()"
        [label]="'shared.qr.dialog.share_qr' | translate"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-outlined p-button-rounded"
        icon="pi pi-share-alt"
        (click)="shareLink()"
        [label]="'shared.qr.dialog.share_link' | translate"
      ></button>
    </div>
  </ng-template>
</p-dialog>
